export enum SearchModalColumns {
  id,
  patient,
  physician,
  territory,
  phase,
  status,
}
